module.exports = __webpack_public_path__ + "img/phone.3655345b.png";